/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsThumbtack: {
  name: 'thumbtack';
  data: string;
} = {
  name: 'thumbtack',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.146 1.146a.5.5 0 0 1 .708 0l1 1 4 4 1 1a.5.5 0 0 1-.708.708l-.646-.647-3.457 3.457.447 2.238a.5.5 0 0 1-.136.452l-1.5 1.5a.5.5 0 0 1-.708 0L5 11.707l-3.646 3.647a.5.5 0 0 1-.708-.708L4.293 11 1.146 7.854a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 0 1 .452-.136l2.238.447L8.793 2.5l-.647-.646a.5.5 0 0 1 0-.708Zm-2.793 9.5h.001L8.5 13.794l.957-.957-.447-2.238a.5.5 0 0 1 .136-.452L12.793 6.5 9.5 3.207 5.854 6.854a.5.5 0 0 1-.452.136l-2.238-.447-.957.957 3.146 3.146Z" fill="currentColor"/></svg>`,
};
